import React from "react";
import PropTypes from "prop-types";
const AudioIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title,
  tipText,
  tipFor,
  isTipHtml,
  href,
  viewbox
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox={viewbox || "0 0 24 24"}
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    data-tip={tipText}
    data-for={tipFor}
    data-html={isTipHtml}
    data-testid="AudioIcon"
    onClick={() => {
      if (Boolean(href)) {
        window.open(href, "_blank").focus();
      }
    }}
  >
    <defs>
      <path id="a" d="M0 0h20v20H0V0Z" />
    </defs>
    <g fill="none">
      <path d="M0 0h20v20H0z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="m4.403 13.811 1.643-.513A1.36 1.36 0 0 0 7 12h1v2.173a3.3 3.3 0 0 1-2.5 3.202l-.681.17A1.464 1.464 0 0 1 3 16.125v-.405a2 2 0 0 1 1.403-1.909ZM13.403 11.811l1.643-.513A1.36 1.36 0 0 0 16 10h1v2.173a3.3 3.3 0 0 1-2.5 3.202l-.681.17A1.464 1.464 0 0 1 12 14.125v-.405a2 2 0 0 1 1.403-1.909Z" />
        <path d="M7 6h1v8H7zM16 4h1v8h-1z" />
        <path d="m8.608 3.678 7.196-1.439A1 1 0 0 1 17 3.22V6L7 8V5.64a2 2 0 0 1 1.608-1.962Z" />
        <path d="M8 9c0-.604.368-1.147.928-1.371L9 7.6 7 7v2h1ZM17 7h-1a.656.656 0 0 0-.784-.643L15 6.4 17 5v2Z" />
      </g>
    </g>
  </svg>
);
AudioIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default AudioIcon;
